import { store } from "@betacrew/jars-flux";
import { componentKey, setFormList, setStateList, setTaxYearList, setPayerList, setStatePayrollSubmittedFormsList, setReloadSubmitGridData, setLoadStatePayrollFormsDataState, setSelectedForm, setSubmitStatePayrollFormFees, setDeleteStatePayrollFormsModalOpen, setStatePayrollFormDetailsDrawerOpen, setFiltersLoadingState, setLoadingState, setUrlFormIdParam, setUrlPayerIdParam, setSelectedState, setSelectedTaxYear, setSelectedPayer, setSelectedForms, setAssignStatePayrollFormsToReviewersModal, setShouldGetSubmittedStatePayrollFormsGridData, setStatePayrollSubmitForThisPayerModal } from "./FormStatePayrollSlice";
import { all, put, take, takeLatest } from "redux-saga/effects";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import General from "../../../../../libs/utility/General";
import SubmitFormsDataService from "../../../../../services/SubmitFormsDataService";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import FormsDataService from "../../../../../services/FormsDataService";
import Forms from "../../../../../libs/utility/formsutility/Forms";
import { FORM_LISTING_LOADING_STATES } from "../constants";
import { PAGE_STATE } from "../../../constants/constants";
import RightsManagementDataService from "../../../../../services/RightsManagementDataService";

export const { getStateList, getFormList, getTaxYear, getPayerList, getStatePayrollSubmittedFormsList, viewStatePayrollPDF, loadStatePayrollFormsData, submitForSinglePayer, deleteStatePayrollForms, getFormFields, createStatePayrollZipForDownloadAll, downloadStatePayrollMultiplePDF, assignFormToReviewers } = {

  getStateList: (payload) => {
    return {
      type: "FORM_STATE_PAYROLL/GET_STATES",
      payload
    }
  },
  getFormList: (payload) => {
    return {
      type: "FORM_STATE_PAYROLL/GET_FORMS",
      payload
    }
  },
  getTaxYear: (payload) => {
    return {
      type: "FORM_STATE_PAYROLL/GET_TAXYEAR",
      payload
    }
  },
  getPayerList: (payload) => {
    return {
      type: "FORM_STATE_PAYROLL/GET_PAYER",
      payload
    }
  },
  getStatePayrollSubmittedFormsList: (payload) => {
    return {
      type: "FORM_STATE_PAYROLL/GET_GRID_DATA",
      payload
    }
  },
  viewStatePayrollPDF: (payload) => {
    return {
      type: "FORM_STATE_PAYROLL/VIEW_PDF",
      payload
    }
  },
  loadStatePayrollFormsData: (payload) => {
    return {
      type: "FORM_STATE_PAYROLL/LOAD_STATE_PAYROLL_FORMS_DATA",
      payload
    }
  },
  submitForSinglePayer: (payload) => {
    return {
      type: "FORM_STATE_PAYROLL/SUBMIT_FOR_SINGLE_PAYER",
      payload
    }
  },
  deleteStatePayrollForms: (payload) => {
    return {
      type: "FORM_STATE_PAYROLL/DELETE_STATE_PAYROLL_FORMS",
      payload
    }
  },
  getFormFields: (payload) => {
    return {
      type: "FORM_STATE_PAYROLL/GET_FORM_FIELDS",
      payload
    }
  },
  createStatePayrollZipForDownloadAll: (payload) => {
    return {
      type: "FORM_STATE_PAYROLL/SET_PDF",
      payload
    }
  },
  downloadStatePayrollMultiplePDF: (payload) => {
    return {
      type: "FORM_STATE_PAYROLL/DOWNLOAD_ALL_PDF",
      payload
    }
  },
  assignFormToReviewers: (payload) => {
    return {
      type: "FORM_STATE_PAYROLL/ASSIGN_FORM_TO_REVIEWERS",
      payload
    }
  },
}

function* getStateListAsync(action) {

  try {
    yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_STATE_LIST_LOADING }));
    const { urlStateParam, urlTaxYearParam = null } = action.payload;
    const response = yield SubmitFormsDataService.getStateList()


    const { Message, Status, Data } = response?.data;

    if (Status) {
      if (Data?.StateNames && Data?.TaxYears) {
        const stateList = [...Data.StateNames];
        const taxYearList = [...Data.TaxYears];

        General.addOptionAndValueKeys(stateList, "StateName", "StateName");
        General.addOptionAndValueKeys(taxYearList, "TaxYear", "TaxYear");

        yield all([
          put(setStateList(stateList)),
          put(setTaxYearList(taxYearList))
        ]);
        if (urlStateParam) {
          const findSelectedStateRecord = stateList.find(state => state?.value === urlStateParam)
          if (findSelectedStateRecord) {
            yield put(setSelectedState(findSelectedStateRecord))
          }
        }
        if (urlTaxYearParam) {
          const findSelectedTaxYearRecord = taxYearList.find(taxYear => taxYear?.value === urlTaxYearParam)
          if (findSelectedTaxYearRecord) {
            yield put(setSelectedTaxYear(findSelectedTaxYearRecord))
          }
        }
      }
      else {
        yield put(addNotifications({ heading: "Failed to fetch states", message: Message }));
      }
    }
    else {
      yield put(addNotifications({ heading: "Failed to fetch states", message: Message }));
    }
  }
  catch (error) {
    console.log(error)
    yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
  } finally {
    yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_STATE_LIST_READY }));
  }
}

function* getFormsListAsync(action) {

  try {
    yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORMS_LIST_LOADING }));
    const params = action.payload.stateName;
    const { urlFormIdParam = null } = action.payload;
    const response = yield SubmitFormsDataService.getFormList(params)
    const { formId } = action.payload;

    const { Message, Status, Data } = response?.data;

    if (Status === 1) {
      if (Data) {
        General.addOptionAndValueKeys(Data, "FormName1", "FormId");

        if (urlFormIdParam) {
          const findSelectedFormRecord = Data.find(item => item?.value == urlFormIdParam)
          if (findSelectedFormRecord) {
            const formListWFormId = Data.map(item => { return { ...item, FormId: item.FormId, FormName1: item.FormName1, FormShortName: item?.FormName1 } });
            const form = formListWFormId.find(form => form?.FormId == findSelectedFormRecord.FormId);
            if (findSelectedFormRecord && form) {
              if (form) {
                yield put(setSelectedForm(form))
              }
            }
          }
        }
        else {
          const formListWFormId = Data.map(item => { return { ...item, FormId: item.FormId, FormName1: item.FormName1, FormShortName: item?.FormName1 } });
          yield put(setFormList(formListWFormId))

          const form = formListWFormId.find(form => form.FormId == formId);

          if (formId && form) {
            if (form) {
              yield put(setSelectedForm(form))
            }
          }
        }
        yield put(setUrlFormIdParam(null));
      }
      else {
        yield put(addNotifications({ heading: "Error", message: "Forms not found" }));
      }
    }
    else {

      yield put(addNotifications({ heading: "Error", message: Message }));
    }
  }
  catch (error) {
    console.log(error)
    yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
  } finally {
    yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORMS_LIST_READY }));
  }
}

function* getPayerListAsync(action) {
  try {
    yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_PAYERS_LOADING }));

    const { urlPayerIdParam = null } = action.payload;

    const params = action.payload.formId;

    const response = yield FormsDataService.getCascadePayers(params);

    const { Message, Status, Data } = response?.data;

    if (Status === 1) {
      if (Data.length > 0) {
        General.addOptionAndValueKeys(Data, "LastName", "PayerDetailId");

        yield put(setPayerList(Data))
        if (urlPayerIdParam) {
          const findSelectedPayerRecord = Data.find(item => item?.value == urlPayerIdParam)
          if (findSelectedPayerRecord) {
            yield (put(setSelectedPayer(findSelectedPayerRecord)))
          }
          yield put(setUrlPayerIdParam(null));
        }
      }
    }
    else {
      yield put(addNotifications({ heading: "Error", message: Message }));
    }
  }
  catch (error) {
    console.log(error)
    yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
  } finally {
    yield put(setFiltersLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_PAYERS_READY }));
  }
}

function* getStatePayrollSubmittedFormsListAsync(action) {
  try {
    yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORMS_LIST_LOADING }));
    const { pageNumber, pageSize, jsonPreferences, payerId, formId, taxYear, formname, formType, statustype, filingType, payeeName, payeeTIN, readyToSubmitTabCheckboxes } = action.payload;

    const payload = {
      "sort": null,
      "page": pageNumber,
      "pageSize": pageSize,
      "group": null,
      "filter": null,
      "jsonPreferences": jsonPreferences,
      "payerId": payerId,
      "formId": formId,
      "taxyear": taxYear,
      "formname": formname,
      "statustype": statustype,
      "filingType": filingType? filingType : "",
      "payeeName": payeeName,
      "payeeTIN": payeeTIN,
    };

    const response = yield SubmitFormsDataService.getStatePayrollSubmittedFormsList(payload);

    if (response && response.data) {
      const { Status, Message } = response.data;

      const Data = General.extractDataFromResponseData(response.data);

      if (Status === 1) {
        if (Data.length > 0) {
          yield put(setStatePayrollSubmittedFormsList(Data));
        } else {
          yield put(setStatePayrollSubmittedFormsList([]));
          yield put(setSelectedForms([]));
        }
      } else {
        yield put(addNotifications({ heading: "Please try again", message: Message }));
      }
    }
  } catch (error) {
    console.log(error);
    yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
  } finally {
    yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.FETCHING_FORMS_LIST_READY }));
    yield put(setReloadSubmitGridData(false));
  }
}


function* viewStatePayrollPDFAsync(action) {
  try {
    const { highlightedStatePayrollForm, selectedForm, selectedPayer, viewOnly = false } = action.payload

    const data = {
      "formId": highlightedStatePayrollForm.FormId,
      "PayerID": selectedPayer.PayerDetailId,
      "formTypeId": selectedForm.value,
      "isUnmask": false,
      "employerId": 0
    }

    const response = yield SubmitFormsDataService.viewStatePayrollPDF(data);

    const { Message, Status, Data } = response?.data;

    if (Status === 1) {
      if (Status === 1 && Data) {
        if (viewOnly) {
          General.openBase64FileInNewTab(Data.Base64, Data.Name);
        }
      }
      else {
        yield put(addNotifications({ heading: "Error", message: "PDF not found" }));
      }
    }
    else {
      yield put(addNotifications({ heading: viewOnly ? "Failed to open a PDF" : "Failed to download a PDF", message: Message }));
    }


  }
  catch (error) {
    const { viewOnly = false } = action?.payload
    console.log(error)
    yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
  }

}

function* loadStatePayrollFormsDataAsync(action) {
  try {
    const { PayerId, selectedForm, TaxYear, submitType, fromDrawer = false, fromVerificationPopup, considerAllSelectedFormsForThisPayer = false } = action?.payload;

    yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_LOADING : FORM_LISTING_LOADING_STATES.FETCHING_LOAD_FORMS_DATA_LOADING }));

    const data = {
      payerId: PayerId,
      formId: selectedForm?.value,
      taxYear: TaxYear,
      formname: selectedForm?.label,
      statustype: "NotSubmitted",
      filingType: ""
    }

    const response = yield SubmitFormsDataService.loadStatePayrollFormsData(data);

    if (response?.data) {
      const { Message, Status, Data } = response?.data;

      if (Status === 1) {
        if (Data) {
          yield put(setLoadStatePayrollFormsDataState({ state: true, type: submitType, fromDrawer, fromVerificationPopup, considerAllSelectedFormsForThisPayer }));
        }
        else {
          yield put(addNotifications({ heading: "Error", message: "Forms not found" }));
        }
      }
      else {
        yield put(addNotifications({ heading: "Failed to load form data", message: Message }));
      }
    }
  }
  catch (error) {
    console.log("loadStatePayrollFormsDataAsync:", error)
    yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
  } finally {
    const { fromDrawer } = action?.payload;

    yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.FETCHING_LOAD_FORMS_DATA_FROM_DRAWER_READY : FORM_LISTING_LOADING_STATES.FETCHING_LOAD_FORMS_DATA_READY }));
  }
}

function* submitForSinglePayerAsync(action) {
  try {
    const { PayerId, FormName, TaxYear, PayerName, statePayrollSubmittedFormsList, selectedReadyToSubmitForms, fromDrawer, openSubmitForThisPayerModal = true, highlightedForm = null, considerAllSelectedFormsForThisPayer } = action?.payload;

    yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.SUBMIT_FOR_THIS_PAYER_FROM_DRAWER_LOADING : FORM_LISTING_LOADING_STATES.SUBMIT_FOR_THIS_PAYER_LOADING }));

    const data = {
      PayerId,
      FormName,
      TaxYear,
      PayerName,
      FormModel: Forms.getJsonPreferences(statePayrollSubmittedFormsList, selectedReadyToSubmitForms, "", (fromDrawer && !considerAllSelectedFormsForThisPayer ? highlightedForm : null)),
    }

    const response = yield SubmitFormsDataService.submitForSinglePayer(data);

    if (response?.data) {
      const { Message, Status, Data } = response?.data;

      if (Status === 1) {
        if (Data) {
          yield put(setSubmitStatePayrollFormFees(Data));
          if (!fromDrawer) {

            yield put(setStatePayrollSubmitForThisPayerModal(true));
          }
        }
        else {
          yield put(addNotifications({ heading: "Error", message: "Failed to submit for the payer" }));
        }
      } else {
        yield put(addNotifications({ heading: "Failed to submit form for this payer", message: Message }));
      }
    }

  } catch (error) {
    console.log(error)
    yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
  } finally {
    const { fromDrawer = false } = action?.payload;
    yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.SUBMIT_FOR_THIS_PAYER_FROM_DRAWER_READY : FORM_LISTING_LOADING_STATES.SUBMIT_FOR_THIS_PAYER_READY }));
  }
}

function* deleteStatePayrollFormsAsync(action) {

  try {
    const { statePayrollSubmittedFormsList, toDeleteData, selectedForm, fromDrawer = false } = action.payload;

    yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.DELETE_BULK_FORM_FROM_DRAWER_LOADING : FORM_LISTING_LOADING_STATES.DELETE_BULK_FORM_LOADING }))

    let jsonData = statePayrollSubmittedFormsList.map(item => {
      let obj = {
        value: item.FormId, ScheduleDate: "", EmailKey: item.IsEmailRecipient, UspsKey: item.IsUSPSMail, TinKey: item.IsTinCheck, StateKey: item.IsState, State: "", Foreignkey: "0"
      };
      obj.key = toDeleteData.some(deletedItem => {
        return deletedItem.FormId === item.FormId;
      });
      return obj;
    });
    const data = {
      jsonPreferences: jsonData,
      formId: selectedForm.value,
      formName: selectedForm.label
    }

    const response = yield SubmitFormsDataService.deleteStatePayrollForms(data);

    const { Message, Status } = response?.data;
    if (Status === 1) {
      yield put(setStatePayrollSubmittedFormsList([]));
      yield put(addNotifications({ heading: "Success", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
      yield put(setStatePayrollFormDetailsDrawerOpen(false));
      yield put(setReloadSubmitGridData(true));
    } else {
      yield put(setDeleteStatePayrollFormsModalOpen({ state: false }))
      yield put(addNotifications({ heading: "Failed to delete selected forms", message: Message, variant: TOASTER_VARIANT.DANGER }));
    }

  } catch (error) {
    console.log(error)
    yield put(setDeleteStatePayrollFormsModalOpen({ state: false }))
    yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));

  } finally {
    const { fromDrawer = false } = action?.payload;
    yield put(setLoadingState({ state: fromDrawer ? FORM_LISTING_LOADING_STATES.DELETE_BULK_FORM_FROM_DRAWER_READY : FORM_LISTING_LOADING_STATES.DELETE_BULK_FORM_READY }))
  }

}

function* createStatePayrollZipForDownloadAllAsync(action) {

  try {

    const { payer, formTypeID, formName, statePayrollSubmittedFormsList, selectedReadyToSubmitForms } = action.payload
    const data = {
      jsonPreferences: Forms.getJsonPreferences(statePayrollSubmittedFormsList, selectedReadyToSubmitForms, formTypeID, null),
      payerName: payer.label,
      maskTin: false
    }
    const response = yield SubmitFormsDataService.createStatePayrollZipForDownloadAll(data);
    const { Message, Status } = response?.data;

    if (Status) {

      yield put(downloadStatePayrollMultiplePDF({ formName: formName }))
    } else {
      yield put(addNotifications({ heading: "Failed to create zip file", message: Message, variant: TOASTER_VARIANT.DANGER }));
    }

  } catch (error) {
    console.log(error)
    yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
  } finally {
    yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.CREATE_ZIP_READY }))
  }

}

function* downloadStatePayrollMultiplePDFAsync(action) {

  try {
    yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.DOWNLOAD_MULTIPLE_PDF_LOADING }))

    const { formName } = action.payload
    const response = yield SubmitFormsDataService.downloadStatePayrollMultiplePDF(formName);
    const { Message, Status, Data } = response?.data;
    if (Status) {
      General.downloadFileFromBase64(Data.Base64, Data.Name)
      yield put(addNotifications({ heading: "Successfully downloaded multiple PDFs.", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
    } else {
      yield put(addNotifications({ heading: "Failed to download multiple pdf", message: Message, variant: TOASTER_VARIANT.DANGER }));
    }

  } catch (error) {
    console.log(error)
    yield put(addNotifications({ heading: "Error", message: "Ran into an error. Please try again or contact support." }));
  } finally {
    yield put(setLoadingState({ state: FORM_LISTING_LOADING_STATES.DOWNLOAD_MULTIPLE_PDF_READY }))
  }

}
function* assignFormToReviewersAsync(action) {
  try {
    yield put(setLoadingState({ state: PAGE_STATE.LOADING }));

    const { formIds, payerId, formName, payerName, taxyear, formtypeId, reviewerIds } = action?.payload;

    const params = {
      formIds,
      payerId,
      formName,
      payerName,
      taxyear,
      formtypeId,
      reviewerIds: reviewerIds.map(r => r.UserId).toString(),
    }

    const response = yield RightsManagementDataService.submitforReview(params);

    const { Message, Status, } = response?.data;

    if (Status) {
      yield put(addNotifications({ heading: "Success", message: Message, variant: TOASTER_VARIANT.SUCCESS }));
      yield put(setAssignStatePayrollFormsToReviewersModal(false));
      yield put(setStatePayrollFormDetailsDrawerOpen(false));
      yield put(setStatePayrollSubmittedFormsList([]))
      yield put(setShouldGetSubmittedStatePayrollFormsGridData({
        gridData: true,
        updatePagination: false,
      }))
    } else {
      yield put(addNotifications({ heading: "Failed to assign forms to reviewers", message: Message }));
    }

  } catch (error) {
    console.log(error)
    yield put(addNotifications({ heading: "Failed to assign forms to reviewers", message: "Ran into an error, please try again" }));
  } finally {
    yield put(setLoadingState({ state: PAGE_STATE.PAGE_READY }));
  }
}


function* rootSaga() {
  yield all([
    takeLatest(getStateList().type, getStateListAsync),
    takeLatest(getFormList().type, getFormsListAsync),
    takeLatest(getPayerList().type, getPayerListAsync),
    takeLatest(getStatePayrollSubmittedFormsList().type, getStatePayrollSubmittedFormsListAsync),
    takeLatest(viewStatePayrollPDF().type, viewStatePayrollPDFAsync),
    takeLatest(loadStatePayrollFormsData().type, loadStatePayrollFormsDataAsync),
    takeLatest(submitForSinglePayer().type, submitForSinglePayerAsync),
    takeLatest(deleteStatePayrollForms().type, deleteStatePayrollFormsAsync),
    takeLatest(createStatePayrollZipForDownloadAll().type, createStatePayrollZipForDownloadAllAsync),
    takeLatest(downloadStatePayrollMultiplePDF().type, downloadStatePayrollMultiplePDFAsync),
    takeLatest(assignFormToReviewers().type, assignFormToReviewersAsync)
  ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);